import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ArrowForkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-fork",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 3h5v5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 3h-5v5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"
    }, null), _createTextVNode(" ")]);
  }
};